
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-started/it",
      function () {
        return require("private-next-pages/getting-started/it.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getting-started/it"])
      });
    }
  